export var getPageSize = function getPageSize(size, layout) {
  var presets = {
    medium: layout.pageWidth,
    small: "calc(".concat(layout.pageWidth, " - 100pt)"),
    mini: "calc(".concat(layout.pageWidth, " - 180pt)"),
    large: "calc(".concat(layout.pageWidth, " + 100pt)")
  };
  var presetValue = presets[size];
  if (!presetValue) return size;
  return presetValue;
};